import { Component, input } from '@angular/core';

@Component({
  selector: 'uw-kbd',
  standalone: true,
  template: `<kbd class="inline-flex h-5 min-w-5 items-center justify-center rounded border border-line-strong bg-surface-sunken px-1.5 text-[10px] font-semibold text-secondary"><ng-content /></kbd>`,
})
export class UwKbd {
  readonly shortcut = input<string>('');
}
